import { Components, Theme } from "@mui/material";
import { mainColours } from "./colors";

export const muiMenu: Components<Omit<Theme, "components">> = {
  MuiMenu: {
    styleOverrides: {
      paper: {
        boxShadow: "0px 1px 4px 0px #00000040",
        border: 0,
        borderRadius: "10px"
      },
      root: ({ theme }) => ({
        marginTop: theme.spacing(1),
        borderRadius: "6px",
        "& .MuiList-root": {
          padding: 0,
          margin: 0
        }
      })
    }
  },
  MuiMenuItem: {
    styleOverrides: {
      root: ({ ownerState, theme }) => {
        return {
          fontSize: 14,
          padding: "10px",
          color: theme.palette.text.primary,
          fontWeight: 400,
          border: "1px solid transparent",
          borderRadius: "6px",
          margin: "10px 10px",
          "&:hover": {
            backgroundColor: mainColours.background.hover,
            ...(ownerState.disabled && {
              color: mainColours.text.inactiveHover
            })
          },
          ...(ownerState.disabled && {
            "& .MuiOutlinedInput-input": {
              color: theme.palette.text.disabled
            }
          }),
          "& .MuiSvgIcon-root, svg": {
            fontSize: 20,
            height: 20,
            width: 20,
            color: theme.palette.text.secondary,
            fill: theme.palette.text.secondary,
            marginRight: theme.spacing(1.5)
          },
          ...(ownerState.divider && {
            borderColor: theme.palette.divider
          }),
          "&.Mui-selected": {
            fontWeight: 500,
            backgroundColor: theme.palette.primary.light,
            color: mainColours.text.accent,
            "&:hover": {
              backgroundColor: theme.palette.primary.light
            }
          }
        };
      }
    }
  }
};
